import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { Region } from '../region.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class RegionsResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient) {}

  query(region_type: string, params?: QueryParams): Observable<Region[]> {
    const url = region_type ? `${this.apiRoot}/regions/${region_type}` : `${this.apiRoot}/regions`;
    return this.http.get<Region[]>(url, { params });
  }
}

((window as any).xplenty as angular.IModule).service('Region', downgradeInjectable(RegionsResource));
